import React, { useState } from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import parse from "html-react-parser";
import SpeedTestResult from "./SpeedTestResult.js";
import CalculateUploadTime from "./CalculateUploadTime.js";

const UploadSpeedTestContainer = () => {
  const [speedCounter, setSpeedCounter] = useState(0);
  const [fileSize, setFileSize] = useState(0);
  const [result, setResult] = useState();
  const [speedType, setSpeedType] = useState("Mbps");
  const [sizeType, setSizeType] = useState("MB");
  const { getTextByKey, getPageText } = useContent();

  const handleClick = () => {
    if (result) {
      setResult(null);
      setFileSize(0);
      setSpeedCounter(0);
    } else {
      CalculateUploadTime(
        speedCounter,
        fileSize,
        setResult,
        speedType,
        sizeType
      );
    }
  };
  return (
    <div className="upload-speed-test-container">
      <div className="first-speed-section">
        <div className="speed-check-section">
          <h3 className="speed-test-steps-title">
            {getTextByKey("speed-test-step1")}
          </h3>
          <iframe
            title="speed-test-iframe"
            className="speed-test-iframe"
            src="https://jumbomail.speedtestcustom.com"
            scrolling="no"
          ></iframe>
        </div>

        <div className="speed-calc-section">
          <h3 className="speed-test-steps-title">
            {getTextByKey("speed-test-step2")}
          </h3>
          <div className="calc-speed-fildes">
            <h4 className="upload-speed-title">
              {getTextByKey("Upload-Speed-Title")}
            </h4>
            <div className="Upload-Speed-instructions">
              {getTextByKey("Upload-Speed-instructions")}
            </div>
            <div className="upload-speed-input-container">
              <span
                className="speed-test-sign"
                onClick={() =>
                  setSpeedCounter(speedCounter > 0 ? speedCounter - 1 : null)
                }
              >
                -
              </span>
              <input
                id="file-size"
                type="number"
                value={speedCounter}
                min="0"
                max="1000"
                onChange={(e) => setSpeedCounter(e.target.value)}
              />
              <span
                className="speed-test-sign"
                id="file-size-plus"
                onClick={() => setSpeedCounter(speedCounter + 1)}
              >
                +
              </span>
              <select
                id="file-size"
                onChange={(e) => setSpeedType(e.target.value)}
                defaultValue="Mbps"
              >
                <option value="Kbps">Kbps</option>
                <option value="Mbps">Mbps</option>
                <option value="Kbps">Kbps</option>
                <option value="Gbps">Gbps</option>
              </select>
            </div>
            <h4 className="upload-speed-title">
              {getTextByKey("Upload-files-Size")}
            </h4>
            <div className="upload-speed-input-container">
              <span
                className="speed-test-sign"
                id="file-size-minus"
                onClick={() => setFileSize(fileSize > 0 ? fileSize - 1 : 0)}
              >
                -
              </span>
              <input
                id="file-size"
                type="number"
                value={fileSize}
                min="0"
                onChange={(e) => setFileSize(e.target.value)}
              />
              <span
                className="speed-test-sign"
                id="file-size-plus"
                onClick={() => setFileSize(fileSize + 1)}
              >
                +
              </span>
              <select
                id="file-size"
                onChange={(e) => setSizeType(e.target.value)}
                defaultValue="MB"
              >
                <option value="KB">KB</option>
                <option value="MB">MB</option>
                <option value="KB">KB</option>
                <option value="GB">GB</option>
              </select>
            </div>
            <div className="speed-calc-botton-container">
              <button className="speed-calc-button" onClick={handleClick}>
                {result
                  ? getTextByKey("speed-reset")
                  : getTextByKey("speed-calculate")}
              </button>
            </div>
            <SpeedTestResult
              result={result}
              getTextByKey={getTextByKey}
              sizeType={sizeType}
              fileSize={fileSize}
            />
          </div>
        </div>
      </div>
      <div className="speed-info-container">
        {getPageText().TextBox ? parse(getPageText().TextBox) : null}
      </div>
    </div>
  );
};

export default UploadSpeedTestContainer;
